import { WarningAmberRounded } from "@mui/icons-material";
import { MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { forwardRef, useEffect } from "react";
import { FormattedMessage } from "react-intl";

import { PlayerIframe } from "@/features/player/player-iframe";
import { useStore } from "@/shared/lib/store/use-store.js";

import { PlayerError } from "./player-error";
import { PlayerBox } from "./player-frame";
import { PlayerSkeleton } from "./player-skeleton";

interface KodikShowPlayerProps {
  readonly imdbId: string;
}

export const KodikShowPlayer = observer(
  forwardRef(({ imdbId }: KodikShowPlayerProps, ref) => {
    const {
      sources: {
        kodik: {
          seasons,
          season,
          translation,
          selectedSeasonTranslations,
          iframeUrl,
          isLoading,
          isError,
          setSeason,
          setTranslation,
          getData,
          resetData,
        },
      },
    } = useStore();

    useEffect(() => {
      getData(imdbId);

      return () => {
        resetData();
      };
    }, [imdbId, getData, resetData]);

    const onSeasonChange = (event: SelectChangeEvent<number>) => {
      setSeason(+event.target.value);
      setTranslation(0);
    };

    const onTranslationChange = (event: SelectChangeEvent<number>) => {
      setTranslation(+event.target.value);
    };

    if (isLoading) {
      return <PlayerSkeleton />;
    }

    if (isError) {
      return <PlayerError />;
    }

    if (seasons.length === 0) {
      return (
        <PlayerBox>
          <WarningAmberRounded />
          <FormattedMessage id="video_not_found" />
        </PlayerBox>
      );
    }

    return (
      <>
        {seasons.length > 1 && (
          <Select
            placeholder="Сезоны"
            value={season}
            size="small"
            onChange={onSeasonChange}
          >
            {seasons.map((item, index) => (
              <MenuItem value={index} key={index}>
                <Typography>{item.title}</Typography>
              </MenuItem>
            ))}
          </Select>
        )}
        {selectedSeasonTranslations?.length > 1 && (
          <Select
            placeholder="Озвучки"
            value={translation}
            size="small"
            onChange={onTranslationChange}
          >
            {selectedSeasonTranslations.map((item, index) => (
              <MenuItem value={index} key={index}>
                <Typography>{item.name}</Typography>
              </MenuItem>
            ))}
          </Select>
        )}
        <PlayerIframe src={iframeUrl} ref={ref} />
      </>
    );
  }),
);
